module.exports = __webpack_public_path__ + "img/blanka-zalan.609e6e2a.jpg";